<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Listing - List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow class="mb-2 mr-1">
            <CCol>
              <div><b>Category</b>: </div>
              <div>
                <CInputRadio
                    @input="choose($event)"
                    value="CORPORATION"
                    :inline="true"
                    name="category-business"
                    id="category-corporation"
                    label="Corporation" :checked="category.toUpperCase() === 'CORPORATION'"/>
                <CInputRadio
                    @input="choose($event)"
                    value="LILO"
                    :inline="true"
                    name="category-business"
                    id="category-lilo" label="Lilo" :checked="category.toUpperCase() === 'LILO'"/>
              </div>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    :placeholder="category.toUpperCase() === 'LILO' ? 'Search by Usaha/Merek' : 'Search By Nama Perusahaan'"
                    @input="search($event)"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="setLabelFields"
            :items-per-page="100"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #action="data">
              <td>
                <div class="button-table" v-if="data.item.flag === 'REJECT'">
                  <CButton
                    color="success"
                    class="mb-0 mr-1"
                    @click="rowClickedDetail(data.item.business_inquiry_id)"
                    >details</CButton
                  >
                </div>
                <div class="button-table" v-else>
                  <CButton
                    color="primary"
                    class="mb-0 mr-1"
                    @click="rowClickedEdit(data.item.business_inquiry_id)"
                    >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="searchBusinessInquiry(lastSearch, 'REFRESH', category)"
            >
              Refresh
            </div>
            <div
              class="pagination-btn-back"
              @click="searchBusinessInquiry(lastSearch, 'BACK', category)"
            >
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div
              class="pagination-btn-next"
              @click="searchBusinessInquiry(lastSearch, 'NEXT', category)"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";

export default {
  name: "BusinessInqueryListing",
  computed: {
    setLabelFields() {
      return this.category === "CORPORATION" ? this.fields : this.fieldsLilo
    }
  },
  data() {
    return {
      items: [],
      category: "CORPORATION",
      businessInquiryData: {
        flag: "FOLLOW UP",
      },
      fields: [
        { key: "business_inquiry_id", label: "ID" },
        { key: "company_name", label: "Nama Perusahaan" },
        { key: "flag", label: "Status" },
        { key: "updated_at", label: "Last Update" },
        { key: "action", label: "Action" },
      ],
      fieldsLilo: [
        { key: "business_inquiry_id", label: "ID" },
        { key: "company_name", label: "Nama Usaha/Merek" },
        { key: "flag", label: "Status" },
        { key: "updated_at", label: "Last Update" },
        { key: "action", label: "Action" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      lastSearch: "",
    };
  },
  mounted() {
    this.authentication();
  },
  created() {
    this.lastSearch = this.$route.query.search || ""
    this.category = this.$route.query.category || "CORPORATION"
    this.activePage = this.$route.query.page || 1
    this.searchBusinessInquiry(this.lastSearch, '', this.category.toUpperCase());
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "SALES" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    setHistory() {
      const q = '?page=' + this.activePage + '&category=' + this.category + '&search=' + this.lastSearch
      window.history.replaceState(null, null, q);
    },
    search(e) {
      this.lastSearch = e
      this.searchBusinessInquiry(e, '', this.category)
    },
    choose(e) {
      this.category = e.target.value
      this.searchBusinessInquiry(this.lastSearch, "", this.category)
    },
    getBadge(status) {
      switch (status) {
        case "NEW":
          return "success";
        case "FOLLOW UP":
          return "secondary";
      }
    },
    searchBusinessInquiry(event, action, cat = "CORPORATION", except = "NEW") {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
        .get(
          `${this.domain}/v1/business/data?page=${this.activePage}&per_page=100&q=${event}&category=${cat}&except=${except}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.items = response.data.data;
            // const flag = "NEW";
            // this.items = response.data.data.filter(function(item) {
            //   return item.flag !== flag;
            // });
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else if (response.data.data.length === 0 && action === "") {
            this.items = response.data.data;
          }
          this.setHistory()
        })
        .catch((e) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: e.response.data.message.id || "something went wrong",
          });
        });
      this.setHistory()
    },
    rowClickedEdit(item) {
      this.$router.push({
        path: `/business_inquiry/listing/edit/${item}`,
      });
    },
    rowClickedDetail(item) {
      this.$router.push({
        path: `/business_inquiry/listing/detail/${item}`,
      });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    faqCreate() {
      this.$router.push({ path: `/business_inquiry/create` });
    },
  },
};
</script>

<style scoped>
@import "./BusinessInquiry.css";
</style>
